import React from 'react';
import styles from './Loader.module.scss';

export default (props) => <div className={styles.loader} style={{ minHeight: props.minHeight }} />;
